import { Component, computed, effect, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location as queryState } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { GLOBAL_CONSTANT, HeaderComponent } from '@lp-ui-lib';
import { AssetsService } from '@lp-ui-lib';
import { SidebarComponent } from '@lp-ui-lib';
import { UiService } from '@lp-ui-lib';
import { I18nService } from '@lp-ui-lib';
import { App_Routes } from '@lp-ui-lib';
import { PlantOverviewContentComponent } from './plant-overview-content/plant-overview-content';
import { NzImageModule } from 'ng-zorro-antd/image';

@Component({
  selector: 'app-plant-overview',
  imports: [
    SidebarComponent,
    PlantOverviewContentComponent,
    NzImageModule,
    //HeaderComponent,
    NzIconModule,
    HeaderComponent,
  ],
  templateUrl: './plant-overview.html',
  styleUrls: ['./plant-overview.scss'],
})
export class PlantOverviewComponent {
  // Inject services
  private assetsService = inject(AssetsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private ui = inject(UiService);
  private queryState = inject(queryState);
  public i18n = inject(I18nService);

  // Signals
  loading = signal(true);
  plant = signal<any>(null);
  emptyResults = signal(false);
  filterStatus = signal<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  getState = signal<any>(this.queryState.getState());

  // Device type signals
  isMobile = computed(() => this.ui.IsMobile());
  isTablet = computed(() => this.ui.IsTablet());
  isDesktop = computed(() => this.ui.IsDesktop());

  // Extract plant ID from route
  plantID = signal<number>(+this.route.snapshot.paramMap.get(GLOBAL_CONSTANT.ID)!);

  // Effect to subscribe to plant data
  constructor() {
    effect(() => {
      this.loading.set(true);
      this.filterStatus.set(this.getState()?.status ?? null);
      const result: any = this.assetsService.plantsState();
      this.loading.set(false);

      const newPlant = result.plants
        .map((plant: any) => plant.findLocation(this.plantID()))
        .find((plant: any) => !!plant && plant.objectID === this.plantID());

      if (newPlant) {
        this.plant.set(newPlant);
        this.emptyResults.set(false);
      } else {
        this.emptyResults.set(true);
      }
    });
  }

  // Called from template
  sortCritFirst(buildings: any[]) {
    return buildings.sort((x, y) =>
      x.critical === y.critical ? GLOBAL_CONSTANT.ZERO : x.critical ? -1 : GLOBAL_CONSTANT.ONE
    );
  }

  toLowerItem(building: any) {
    this.router.navigate([App_Routes.PLANT, building.objectID]);
  }

  // UI setup effect (replaces ngAfterViewInit)
  uiSetupEffect = effect(() => {
    const data = this.route.snapshot.data;
    this.ui.updateTabIndex(data[GLOBAL_CONSTANT.TAB_INDEX]);
    this.ui.updateBackBtn(data[GLOBAL_CONSTANT.BACK_BUTTON]);
  });
}
